import React from 'react';
import { ZapIcon } from 'lucide-react';
import { heroChecklist } from '../data/content';
import { CheckItem } from './CheckItem';
export function ProductIntro() {
  return <section className="bg-white px-4 py-7 text-center md:px-12" data-id="element-141" data-mp="1no5y6rooeneq">
      <h2 className="mx-auto max-w-2xl text-lg font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-2xl" data-id="element-142" data-mp="1npz2w1fqaxk3">
        El sistema completo 4 en 1 para electricistas domiciliarios
      </h2>
      <p className="mt-1.5 text-2xl font-extrabold uppercase leading-tight tracking-tight text-sky-600 md:text-3xl" data-id="element-143" data-mp="2gewmc7vof0ef">
        <ZapIcon className="mr-1.5 inline h-6 w-6 -translate-y-1 fill-amber-400 text-amber-500 md:h-8 md:w-8" aria-hidden data-id="element-144" data-mp="26n0c5ygbfjtu" />
        Combo Completo Electricistas
      </p>
      <p className="mt-1.5 text-xs font-bold uppercase leading-tight tracking-wide text-amber-700 md:text-sm" data-id="element-145" data-mp="2bkaak3lon5tt">
        Casos prácticos y herramientas profesionales listas para consultar.
      </p>
      <p className="mt-1 text-sm leading-snug text-slate-600" data-id="element-146" data-mp="343pahi6243yh">
        Disyuntores y térmicas • Tomacorrientes e iluminación • Fallas complejas • Diagnóstico profesional
      </p>

      <h3 className="mt-4 text-base font-extrabold uppercase text-blue-950" data-id="element-147" data-mp="phwwrwkp4ucc">Los cuatro tomos principales del sistema</h3>
      <ul className="mt-2 grid gap-x-6 gap-y-1 text-left text-sm leading-snug text-slate-600 md:grid-cols-2 md:text-base" data-id="element-148" data-mp="146t57uqo09dh">
        {heroChecklist.map(item => <CheckItem key={item} data-id="element-149" data-mp="1d552gfm1e5ew">{item.replace(/\.$/, '')}</CheckItem>)}
      </ul>
    </section>;
}